export const blanket = {
  msrp: 49.99,
  infoLink: 'https://www.teamtriton.com/custom-blankets.html',
  items: [
    {
      number: 'BLK100',
      hasModel: false,
    },
    {
      number: 'BLK101',
      hasModel: false,
    },
    {
      number: 'BLK102',
      hasModel: false,
    },
    {
      number: 'BLK103',
      hasModel: false,
    },
    {
      number: 'BLK104',
      hasModel: false,
    },
    {
      number: 'BLK105',
      hasModel: false,
    },
  ],
};
